import React, { useState, useEffect } from "react";
import { Activity } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { useOrganization } from "@clerk/clerk-react";
// [tutorial disabled] import { driver } from "driver.js";
// [tutorial disabled] import "driver.js/dist/driver.css";
import { useApiFetch } from "src/lib/api";

export default function Active() {
  const [installedAssets, setAssets] = useState(0);
  const { organization } = useOrganization(); 

  /* const orgId = organization?.id;
  console.log("DEBUG] OrgId on Active: ", orgId); */

  const apiFetch = useApiFetch();

  // [tutorial disabled] const disableTutorial = async () => {
    // [tutorial disabled] try {
      // [tutorial disabled] await apiFetch("/auth/disable-tutorial", { method: "POST" });
    // [tutorial disabled] } catch (error) {
      // [tutorial disabled] console.error("Error disabling tutorial:", error);
    // [tutorial disabled] }
  // [tutorial disabled] };

  // [tutorial disabled] /* Display tour tutorial */
  // [tutorial disabled] useEffect(() => {
    // [tutorial disabled] let intervalId = null;

    // [tutorial disabled] const checkForTutorialReady = () => {
      // [tutorial disabled] let step = localStorage.getItem("driver-tutorial-step");
      // [tutorial disabled] const el = document.querySelector("#devices-map");

      // [tutorial disabled] if (step === "active" && el) {
        // [tutorial disabled] clearInterval(intervalId); 
        // [tutorial disabled] startDriver(); 

        // [tutorial disabled] setTimeout(() => {
          // [tutorial disabled] intervalId = setInterval(checkForTutorialReady, 300);
        // [tutorial disabled] }, 1000);
      // [tutorial disabled] }
    // [tutorial disabled] };

    // [tutorial disabled] const startDriver = () => {
      // [tutorial disabled] const driverObj = driver({
        // [tutorial disabled] steps: [
          // [tutorial disabled] {
          // [tutorial disabled] element: "#active-assets",
          // [tutorial disabled] popover: {
            // [tutorial disabled] title: "Active assets",
            // [tutorial disabled] description: "This card shows the active assets live for the organization selected",
            // [tutorial disabled] prevBtnText:  `
              // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
              // [tutorial disabled] </svg>
            // [tutorial disabled] `,
            // [tutorial disabled] doneBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
            // [tutorial disabled] onNextClick: () => {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "device-list");
            // [tutorial disabled] },
            // [tutorial disabled] onCloseClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
            // [tutorial disabled] onPrevClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "mapView");
            // [tutorial disabled] },
          // [tutorial disabled] },
          // [tutorial disabled] onDeselected: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onDestroyed: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onHighlighted: () => {
            // [tutorial disabled] const enablePrev = () => {
              // [tutorial disabled] const prevBtn = document.querySelector('.driver-popover-prev-btn');
              // [tutorial disabled] if (prevBtn) {
                // [tutorial disabled] prevBtn.removeAttribute("disabled");
                // [tutorial disabled] prevBtn.classList.remove('driver-popover-btn-disabled');
                // [tutorial disabled] clearInterval(retry); 
              // [tutorial disabled] }
            // [tutorial disabled] };

            // [tutorial disabled] const retry = setInterval(enablePrev, 100);
            // [tutorial disabled] setTimeout(() => clearInterval(retry), 1000);
          // [tutorial disabled] },
        // [tutorial disabled] },
        // [tutorial disabled] ],
      // [tutorial disabled] });

      // [tutorial disabled] driverObj.drive();
    // [tutorial disabled] };

    // [tutorial disabled] intervalId = setInterval(checkForTutorialReady, 300);

    // [tutorial disabled] return () => {
      // [tutorial disabled] if (intervalId) clearInterval(intervalId);
    // [tutorial disabled] };
  // [tutorial disabled] }, []);

  useEffect(() => {
    /* if (orgId) { */
      async function fetchActiveAssets() {
        try {
          const data = await apiFetch("/api/device-count");
          if (data === null) return; // 0 is a valid count
          setAssets(typeof data === "object" ? 0 : data); 
        } catch (error) {
          console.error("Error fetching active assets:", error);
        }
      }
      fetchActiveAssets();
    /* } */
  }, [/* orgId, */ apiFetch, ]);

  return (
    <Card className="w-full max-w-[316px]" id="active-assets">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-xl font-bold">Active Assets Now</CardTitle>
        <Activity className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="text-base font-medium">{installedAssets}</div>
        <p className="text-xs text-muted-foreground"></p>
      </CardContent>
    </Card>
  );
}